var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "files-container" }, [
    _c("table", { staticClass: "files-table" }, [
      _c("thead", [
        _c("tr", [
          _c("th", [_vm._v(_vm._s(_vm.$t("message.name")))]),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("message.type")))]),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("message.lastRegulation")))]),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("message.actions")))]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.files, function (file) {
          return _c("tr", { key: file._id }, [
            _c("td", [
              _c("div", [
                _c("i", {
                  staticClass: "file-icon",
                  class: _vm.getFileIcon(file),
                  on: {
                    click: function ($event) {
                      return _vm.showViewer(file)
                    },
                  },
                }),
                _vm._v(
                  "\n                    " +
                    _vm._s(file.name) +
                    "\n                "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.getFileType(file)))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.formatDate(file.updatedAt)))]),
            _vm._v(" "),
            _c("td", { staticClass: "actions-column" }, [
              _c(
                "button",
                {
                  staticClass: "action-button open",
                  on: {
                    click: function ($event) {
                      return _vm.handleDoubleClick(file)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "md-icon" }, [
                    _vm._v("open_in_new"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "action-button delete",
                  on: {
                    click: function ($event) {
                      return _vm.deleteFile(file)
                    },
                  },
                },
                [_c("span", { staticClass: "md-icon" }, [_vm._v("delete")])]
              ),
            ]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }